module.exports = __webpack_public_path__ + "img/FrameFoundations_s0_b0_0_1_STSTT_UK.b116648d.png";